import { jsx as _jsx } from "react/jsx-runtime";
import { AssetStatusType } from '@design-stack-vista/vista-assets-sdk';
import { useDrawerThumbnailAsset } from './DrawerThumbnailAssetProvider';
import { observer } from 'mobx-react-lite';
import { DrawerThumbailSpinner } from './DrawerThumbnailSpinner';
import { useLocalization } from '../../../../Localization';
export const DrawerThumbnailUploadStatus = observer(() => {
    const { asset: { status }, showProcessing, } = useDrawerThumbnailAsset();
    const { uploadingLabel } = useLocalization();
    if (status.type !== AssetStatusType.Preparing && status.type !== AssetStatusType.Prepared) {
        return null;
    }
    const uploadProgress = () => {
        if (status.type === AssetStatusType.Preparing) {
            return status.uploadProgress;
        }
        if (status.type === AssetStatusType.Prepared && showProcessing) {
            return 100;
        }
        return -1;
    };
    if (uploadProgress() === -1) {
        return null;
    }
    return _jsx(DrawerThumbailSpinner, { uploadProgress: uploadProgress(), title: uploadingLabel });
});
DrawerThumbnailUploadStatus.displayName = 'DrawerThumbnailUploadStatus';
//# sourceMappingURL=DrawerThumbnailUploadStatus.js.map